<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title=" "
    width="500px"
    height="300px"
    @show="showModal"
  >
    <el-row>
      <!-- 用户信息 -->
      <el-col :span="7" style="max-height: 256px">
        <div class="name-dv" @click="handleOpenMes">
          {{ $store.state.userInfo.userName }}
        </div>
        <div class="messageContainer">
          <div id="messageLabel">用户名:</div>
          <div id="messageValue">{{ $store.state.userInfo.userNum }}</div>
          <div id="messageLabel">职&emsp;位:</div>
          <div id="messageValue">
            <div
              v-for="(item, index) in this.formatPost(
                $store.state.userInfo.gangWei
              )"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </el-col>

      <!-- 密码修改 -->
      <el-col :span="17">
        <div class="functionContainer">
          <el-tabs v-model="activeName">
            <el-tab-pane label="系统设置" name="systemSetting">
              <div v-if="formVisible" class="systemSettingContainer">
                <SystemSetting />
              </div>
            </el-tab-pane>
            <el-tab-pane label="修改密码" name="resetPwd">
              <div v-if="formVisible" class="resetPwdContainer">
                <ResetPwd @closeParent="closeParent" />
              </div>
            </el-tab-pane>
            <!-- 版本更新说明 -->
            <el-tab-pane
              :label="'版本更新说明（当前版本' + curVersion + ')'"
              name="version"
            >
              <div class="version-dv">
                <div v-for="(item, index) of versionComment" :key="index">
                  <div class="version-text">{{ item.version }}</div>
                  <div
                    v-for="(detailItem, dIndex) of formatVersion(
                      item.versionStr
                    )"
                    :key="dIndex"
                  >
                    {{ detailItem }}
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </vxe-modal>
</template>
<script>
import ResetPwd from './resetPwd.vue'
import SystemSetting from './systemSetting.vue'
import { versionComment, curVersion } from '@/assets/js/versionComment'
export default {
  components: {
    ResetPwd,
    SystemSetting
  },
  data() {
    return {
      formVisible: false,
      activeName: 'systemSetting',
      versionComment: versionComment
    }
  },
  computed: {
    curVersion() {
      return curVersion
    }
  },
  methods: {
    // 关闭父窗口
    closeParent() {
      this.formVisible = false
    },
    showModal() {
      // do somthing
      this.activeName = 'systemSetting'
    },
    // 格式化版本更新说明
    formatVersion(str) {
      let res
      // 文本格式格式化为：-[修改]修改bug
      // 往 [] 前后加空格
      res = str.replace(/\s*/gm, "").split(/(?=-)/)
      return res
    },
    formatPost(str) {
      if (str === '') {
        return []
      } else {
        return str.split(',')
      }
    },
    handleOpenMes() {
      // do somthing
    }
  }
}
</script>
<style lang='less' scoped>
@name-height: 100px;
/deep/ .vxe-modal--header {
  background: #ffffff;
  border-bottom: 0;
}
.vxe-modal {
  overflow: hidden;
}
.name-dv {
  width: @name-height;
  height: @name-height;
  margin: 10px;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  box-shadow: rgba(40, 230, 119, 0.35) 1px 1px 5px;
  background-color: #00d3ba;
  color: #fff;
  .fl;
  transition: @slow-transition;
}
/deep/ .vxe-icon--close::before {
  left: 10px !important;
  bottom: 10px !important;
}
.messageContainer {
  margin: 30px 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  #messageLabel {
    font-weight: bold;
    margin-bottom: 5px;
    width: 50px;
    text-align: right;
  }
  #messageValue {
    text-align: center;
    width: calc(100% - 50px);
    max-height: 80px;
    box-sizing: border-box;
    padding-left: 10px;
    overflow: auto;
  }
  #messageValue::-webkit-scrollbar {
    display: none;
    // width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
    // height: auto;
  }

  /*滚动条里面小方块*/
  #messageValue::-webkit-scrollbar-thumb {
    display: none;
    // border-radius: 20px;
    // background-color: skyblue;
    // background-image: -webkit-linear-gradient(
    //   45deg,
    //   rgba(255, 255, 255, 0.2) 25%,
    //   transparent 25%,
    //   transparent 50%,
    //   rgba(255, 255, 255, 0.2) 50%,
    //   rgba(255, 255, 255, 0.2) 75%,
    //   transparent 75%,
    //   transparent
    // );
  }
}
.functionContainer {
  box-sizing: border-box;
  padding: 5px 10px;
  h1 {
    margin: 0;
  }
}
.systemSettingContainer {
  height: 210px;
}
.resetPwdContainer {
  height: 220px;
  box-sizing: border-box;
  padding: 20px 0;
}

.version-dv {
  height: 210px;
  border: 1px solid #f2f3f5;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 10px;
  overflow: auto;

  // .cur-version-text {
  //   font-size: 14px;
  //   // font-weight: bold;
  //   border: 1px solid @primary-color;
  //   color: @primary-color;
  //   padding: 0px 5px;
  //   border-radius: 5px;
  // }
}
.version-text {
  font-weight: bold;
}
/deep/ .el-tabs__nav-prev {
  height: 25px !important;
  line-height: 27px;
}
/deep/ .el-tabs__nav-next {
  height: 25px !important;
  line-height: 27px;
}
</style>